import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Signup from "./components/Signup";
import Signin from "./components/Signin";
import {AuthProvider} from "./context/AuthContext";
import Dashboard from "./components/Dashboard";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import NotFound from "./components/NotFound";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import "./index.css"
import AqqliSuv from "./components/aqlli-suv/Aqqli-suv";
import Monitoring from "./components/aqlli-suv/Monitoring";
import Barchasi from "./components/aqlli-suv/Barchasi";
import Dayver from "./components/dayver/Dayver";
import MonitoringDayver from "./components/dayver/Monitoring";
import BarchasiDayver from "./components/dayver/Barchasi";
import Nasos from "./components/nasos/Nasos";
import MonitoringNasos from "./components/nasos/Monitoring";
import BarchasiNasos from "./components/nasos/Barchasi";

library.add(fas, far, fab)

function App() {
  return (
      <BrowserRouter>
          <AuthProvider>
              <Routes>
                  <Route element={<ProtectedRoutes />}>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/aqlli-suv" element={<AqqliSuv />} />
                      <Route path="/aqlli-suv/monitoring" element={<Monitoring />} />
                      <Route path="/aqlli-suv/aqlli-suv-jadval" element={<Barchasi />} />
                      <Route path="/dayver" element={<Dayver />} />
                      <Route path="/dayver/monitoring" element={<MonitoringDayver />} />
                      <Route path="/dayver/dayver-jadval" element={<BarchasiDayver />} />
                      <Route path="/nasos" element={<Nasos />} />
                      <Route path="/nasos/monitoring" element={<MonitoringNasos />} />
                      <Route path="/nasos/nasos-jadval" element={<BarchasiNasos />} />
                  </Route>
                  <Route path="signup" element={<Signup />} />
                  <Route path="signin" element={<Signin />} />
                  <Route path="*" element={<NotFound />} />
              </Routes>
            {/*<Signup />*/}
            {/*// <Signin />*/}
          </AuthProvider>
      </BrowserRouter>
  );
}

export default App;